export default "__VITE_ASSET__CWW8q381__"